import type { DataTableMode } from '@odo/shared-ui';
import { useDmMessageInbox, useInfiniteDmMessageInbox } from '../../../hooks/useDmMessagesInbox';
import type { DmMessageInboxFilters } from '../../../services/dmMessagesInbox';

interface MessageInboxQueryArgs {
    filters: DmMessageInboxFilters;
    mode: DataTableMode;
    page: number;
    limit: number;
    enabled: boolean;
}

// Both queries run unconditionally (rules of hooks); only the active mode's one is enabled.
export function useMessageInboxQuery({
    filters,
    mode,
    page,
    limit,
    enabled
}: MessageInboxQueryArgs) {
    const isInfinite = mode === 'infinite';
    const shared = { ...filters, limit };
    const paged = useDmMessageInbox({ ...shared, page, enabled: enabled && !isInfinite });
    const infinite = useInfiniteDmMessageInbox({ ...shared, enabled: enabled && isInfinite });
    const active = isInfinite ? infinite : paged;
    const query = {
        rows: active.rows,
        meta: active.meta,
        isLoading: active.isLoading || !enabled,
        // Rows from the previous filters while the new ones load; background refetches don't count.
        isShowingPrevious: active.isPlaceholderData,
        isError: active.isError,
        error: active.error,
        refresh: active.refresh
    };
    const loadMore = {
        onLoadMore: () => void infinite.fetchNextPage(),
        hasMore: infinite.hasNextPage,
        isLoadingMore: infinite.isFetchingNextPage
    };
    return { query, loadMore };
}
